import { CurrencyConversionDto, Currency } from '../types'

export const retrieveCurrencyConversionRate = (
  startingCurrency: Currency,
  targetCurrency: Currency,
  conversionData: CurrencyConversionDto[],
): number | undefined => {
  if (!conversionData.length) {
    return undefined
  }
  for (const el of conversionData) {
    if (el.startingCurrency === startingCurrency && el.targetCurrency === targetCurrency) {
      return el.conversionRate
    } else if (el.startingCurrency === targetCurrency && el.targetCurrency === startingCurrency) {
      return 1 / el.conversionRate
    }
  }
  return undefined
}
